import React from "react";
import { connect } from "react-redux";
import { format } from "date-fns";

const CouponBookings = ({ services, teamMembers, locations, bookings }) => {
  return (
    <div className="max-w-7xl mx-auto">
      <div className="flex flex-col">
        <div className="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
          <div className="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200">
            <table className="min-w-full">
              <thead>
                <tr>
                  <th className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                    Date & Time
                  </th>
                  <th className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                    Location
                  </th>
                  <th className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                    Team Member
                  </th>
                  <th className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                    Service(s)
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white">
                {bookings?.length === 0 && (
                  <tr>
                    <td
                      colSpan={4}
                      className="px-6 py-4 text-center border-b border-gray-200 text-sm leading-5 text-gray-500"
                    >
                      The coupon has not been used yet
                    </td>
                  </tr>
                )}
                {bookings?.map((item, index) => {
                  const teamMember =
                    item.booking.teamMemberID &&
                    teamMembers?.find(
                      (tm) => tm.id == item.booking.teamMemberID
                    );
                  return (
                    <tr key={item.booking.id}>
                      <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 font-medium text-gray-900">
                        {format(new Date(item.booking.date), "dd/MM/yyyy")}{" "}
                        {item.booking.startTime}
                      </td>
                      <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 text-gray-500">
                        {item.booking.locationID &&
                          locations &&
                          locations.find(
                            (location) => location.id == item.booking.locationID
                          )?.name}
                      </td>
                      <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 text-gray-500">
                        {teamMember && teamMember.givenName}{" "}
                        {teamMember && teamMember.familyName}
                      </td>
                      <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 text-gray-500">
                        {item.booking.services &&
                          services &&
                          item.booking.services
                            .map(
                              (i) =>
                                services.find((item) => item.id == i.service)
                                  ?.name
                            )
                            .join(", ")}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const bookings =
    state.coupon?.item?.customers?.items?.filter((item) => item.booking) || [];
  return {
    services: state.service.list,
    teamMembers: state.teamMember.list,
    locations: state.location.list,
    bookings,
  };
};
export default connect(mapStateToProps, {})(CouponBookings);
